// MODIFIED: Fixed missing pagination state and Table props
import React, { useState } from "react";
import {
  CreateTableNew as CreateTable,
  Button,
  SearchBar,
  GeneralMessage,
  // ConfirmationModal
} from "../../../../common/APICommon";
import { StatusBadge } from "../../../../common/Badge";
import { DisapproveReasonModal, ConfirmationModal } from "../../../../common/Modal";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance"; // Set Loan Detail
import ClassIcon from '@mui/icons-material/Class';

import { LoadingSpinner } from "../../../../common/Loading";
import { StrategyTypes, WorkflowStatus } from "../../../../utils/enums";
import { useEmployeeTransactionApprovals } from "../../../hooks/useEmployeeTransactionApprovals";

export function EmployeeTransactionRequest({ user }) {
  const {
    loading,
    data,
    searchTerm,
    setSearchTerm,
    handleAction,
    alertProps
  } = useEmployeeTransactionApprovals(user);

  const [selectedRequest, setSelectedRequest] = useState(null);
  const [showConfirmApproved, setShowConfirmApproved] = useState(false);
  const [showDisapprove, setShowDisapprove] = useState(false);
  const [disapproveTarget, setDisapproveTarget] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);

  const actions = [
    {
      name: "Approve",
      icon: <ThumbUpIcon fontSize="small" />,
      className: "bg-blue-600 hover:bg-blue-700",
      function: (item) => {
        console.log({ item })
        setSelectedRequest(item);
        setShowConfirmApproved(true);
      },
      visible: (item) => item.status === "Pending",
    },
    {
      name: "Disapprove",
      icon: <ThumbDownAltIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: (item) => {
        setDisapproveTarget(item.id);
        setShowDisapprove(true);
      },
      visible: (item) => item.status === "Pending",
    }
  ];

  return (
    <div className="v2-module-container p-4">
      <SearchBar handleFilter={setSearchTerm} value={searchTerm} />

      <CreateTable
        headers={["Ref No.", "Employee", "Vessel", "Status", "Actions"]}
        accessors={["referenceNumber", "employeeFullName", "vesselName", "status", "actions"]}
        data={data}
        actions={actions}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={10}
        totalItems={data?.length || 0}
        customCellRenderer={(item, acc) => {
          if (acc === "status") return <StatusBadge status={item.status} />;
          return null;
        }}
      />

      <ConfirmationModal
        visible={showConfirmApproved}
        onClose={() => setShowConfirmApproved(false)}
        onConfirm={async () => {
          const result = await handleAction(selectedRequest.id, "approve");
          if (result.success) setShowConfirmApproved(false);
        }}
        title="Confirm Approval"
        // MODIFIED: Specific confirmation message
        message={`Are you sure you want to approve this request?`}
        confirmText={"Yes, Approve request"}
        type="info"
      />

      <DisapproveReasonModal
        isOpen={showDisapprove}
        onSave={async (reason) => {
          const result = await handleAction(disapproveTarget, "disapprove", reason);
          if (result.success) setShowDisapprove(false);
        }}
        onClose={() => setShowDisapprove(false)}
      />


      <LoadingSpinner loading={loading} />

      <GeneralMessage
        form={alertProps.showMessage}
        message={alertProps.message}
        isSuccess={alertProps.isSuccess}
      />

    </div>
  );
}